<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6">
          <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">

      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Form controls -->
            <div class="card">
              <!-- Card body -->
              <div class="card-body">
                <form>

                  <div>

                    <div class="row mb-4">
                      <div class="col-md-3">
                        <base-radio v-model="radios.radio1"
                                    name="checked"
                                    class="mb-3 mb-md-5">
                                    Individual
                        </base-radio>
                      </div>
                      <div class="col-4 col-md-3">
                        <base-input class="mb-0"
                                    placeholder="+569"
                                    disabled
                                    v-model="validForm.CodePhoneContact" />
                      </div>
                      <div class="col-8 col-md-6">
                        <base-input class="mb-0"
                                    placeholder="*********"
                                    type="number"
                                    :disabled="radios.radio1=='unchecked'"
                                    :error="(validForm.field.includes('PhoneContact')) ? 'Largo de número teléfono inválido' : ''"
                                    v-model.number="contactSingle.phone" />
                        <small class="form-text">Máximo 8 dígitos</small>
                      </div>
                    </div>

                    <div class="row mb-4">
                      <div class="col-md-6">
                        <base-radio v-model="radios.radio1"
                                    name="unchecked"
                                    class="mb-3">
                                    Importar lista (csv, excel, etc)
                        </base-radio>
                      </div>
                      <div class="col-md-6">
                        <dropzone-file-upload v-show="radios.radio1=='unchecked'" v-model="fileSingle">
                        </dropzone-file-upload>
                        <div class="dropzone-disabled mb-3" v-show="radios.radio1=='checked'" >
                          <span class="mb-0 font-weight-400 text-muted">Arrastra tus archivos aquí...</span>
                        </div>
                      </div>

                      <div class="col">
                        <base-alert type="success" v-show="importadosBien">
                            <span class="alert-inner--icon"><i class="fas fa-thumbs-up mr-2"></i></span>
                            <span class="alert-inner--text">¡Se importaron tus contactos!</span>
                        </base-alert>
                      </div>
                    </div>

                    <base-button type="celcomblue"
                                 :disabled="radios.radio1=='unchecked'"
                                 @click="guardarNuevo(contactSingle)">
                      Agregar
                    </base-button>

                  </div>

                  <!--<base-alert type="success" dismissible class="d-flex align-items-center">
                      <span class="alert-inner--icon"><i class="fas fa-thumbs-up mr-2"></i></span>
                      <span class="alert-inner--text"> Se importaron XXX contactos a la lista.</span>

                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </base-alert>-->

                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Sizes -->
            <div class="card">
              <!-- Card body -->
              <div class="card-body">

                <p class="font-weight-300">Vista previa de la blacklist</p>

                <el-table class="table-responsive table-flush"
                          header-row-class-name="thead-light"
                          :data="array_blacklist">
                    <el-table-column label="Código"
                                     prop="codePhone"
                                     min-width="150px"
                                     sortable>
                      <template v-slot="{row}">
                        {{ row.blacklistPK.codePhone }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Número"
                                     prop="phone"
                                     min-width="150px"
                                     sortable>
                        <template v-slot="{row}">
                          {{ row.blacklistPK.phone }}
                        </template>
                    </el-table-column>
                </el-table>

                <div class="text-right mt-4" v-show="listaTerminada">
                  <button class="btn btn-celcompink btn-fill" @click="finalizarAgregar">Finalizar</button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.card {
  &.disabled {
    background: #e9ecef;
    .card-body {
      opacity: .5;
    }
  }
}
.dropzone-disabled {
  text-align: center;
  background-color: #fff;
  border: 1px dashed #dee2e6;
  border-radius: 0.375rem;
  background-color: #e9ecef;
  cursor: not-allowed;
  padding: 2.25rem 1rem;
}
</style>

<script>
  import FileInput from '@/components/Inputs/FileInput'
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  import { Modal, Dialog } from '@/components';
  import { Select, Option, Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui'

  import { Spanish } from "flatpickr/dist/l10n/es.js"
  flatpickr.localize(Spanish);
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  import moment from 'moment';
  import XLSX from 'xlsx';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, customer_user } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)


  export default {
    name: 'NuevoBlacklist',
    components: {
      FileInput,
      [Select.name]: Select,
      [Option.name]: Option,
      DropzoneFileUpload,
      flatPicker,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      Modal,
      Dialog
    },
    data() {
      return {
        fileSingle: [],
        inputs: {
          file: []
        },
        radios: {
          radio1: 'checked'
        },
        checked: false,
        listaCreada: false,
        listaTerminada: false,
        array_blacklist: [],
        nuevaListaContact: [],
        contactGroup: {},
        contactSingle: {
          phoneCode: "",
          phone: ""
        },
        importadosBien: false,
        validForm:{
          CodePhoneContact:getUser().customer.country.phoneCode,
          PhoneContact:"",
          field:"",
        },
      }
    },

    watch:{

     /**
     * IMPORTAR LISTA DESDE EXCEL
     */
     'fileSingle'(e){

        var self = this;
        //e.stopPropagation(); e.preventDefault();
        //var files = e.dataTransfer.files, f = files[0];
        var files = e, f = files[(files.length-1)];
        var reader = new FileReader();
       
       reader.onload = function(e) {

          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {type: 'array'});
          var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
          var data = XLSX.utils.sheet_to_json(first_worksheet, {header:1});

          console.log("datos importados : ",data);

          let header = "";
          //crea header
          if (data.length > 0) {
            
            data[0].forEach(function(key) {
              
              if(key!="codigo" && key!="numero") {
                  header+=key+"|";
              }
            });
          }

          self.importadosBien = true;

          if((self.contadorContactImportados+data.length) > 40000 ) {

              swal({
                title: "Error limite de contactos excedidos",
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill'
              })
                return false;
            }

          console.log("datos importados header : ",header);

          self.createListBlacklists(data);

        };
        reader.readAsArrayBuffer(f);
     }
    },



    methods: {
      filesChange(files) {
        this.inputs.file = files
      },
      guardarNuevo(contactSingle) {

        this.$loading.show()

        let self = this;
        let user = getUser();

        let nuevoContacto = {
          "blacklistPK" : {
            "codePhone": this.validForm.CodePhoneContact,
            "phone": this.contactSingle.phone,
            "customerUserId": user.customerUserId,
          },
          "customerUser":user,
        };

        if (self.contactSingle.phone == "") {
          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else if ( (user.customer.country.name == "Colombia" && self.contactSingle.phone.toString().length !== 9) || (user.customer.country.name == "Chile" && self.contactSingle.phone.toString().length !== 8) ) {

          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else {

          this.array_blacklist.push(nuevoContacto);

          self.listaTerminada = true;

        }


        self.$loading.hide();

      },
      finalizarAgregar(contactSingle) {

        this.$loading.show()

        let self = this;
        let user = getUser();

        let js = {
          "time_expired":horaAhora(),
          "customer_user":encodeURIComponent(JSON.stringify(user)),
          "blacklist": (JSON.stringify(this.array_blacklist)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.blacklist_add_blacklists, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);
                self.listaTerminada = true;

                self.nuevaListaContact = response.data.data;
                self.showSwal()

              } else {
                console.log("No se pudo crear contacto");
                swal({
                  text: 'No se pudo crear contacto',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })

          .catch(function (error) {
              console.log("No se pudo crear contacto",error);
              swal({
                title: 'No se pudo crear contacto',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

      },
      showSwal() {
        swal({
          text: '¡Blacklist creada con éxito!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success',
          type: 'success',
          }).then(function() {
              window.location.href = "/contactos/blacklist";
        })
      },
      handleDrop(e) {

        var self = this;
        e.stopPropagation(); e.preventDefault();
        var files = e.dataTransfer.files, f = files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {type: 'array'});

          var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
          var data = XLSX.utils.sheet_to_json(first_worksheet, {header:1});

          console.log("datos importados : ",data);

          let header = "";

          //crea header
          if(data.length > 0){
            data[0].forEach(function(key){
              if(key!="codigo" && key!="numero"){
                  header+=key+"|";
              }
            });
          }

          self.importadosBien = true;

       if( (self.contadorContactImportados+data.length) > 40000 ){
        swal({
          title: "Error limite de contactos excedidos",
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger btn-fill'
        })

          return false;

        }

        console.log("datos importados header : ",header);

        self.createListBlacklists(data);

        };
        reader.readAsArrayBuffer(f);
      },
      async createListBlacklists(contacts){

        this.$loading.show()

        var self = this;
         //LOGICA QUE CREA ARRAY DE CONTACTOS
        let nuevoContacto = [];
        var c=0;
         contacts.forEach(function(key){

           var phone = "";
           var phoneCode = "";
            if(c > 0){
              for(var j = 0 ; j < key.length ; j++){

                    if(j == 0){
                        phoneCode=key[j];
                    }
                    if(j == 1){
                        phone=key[j];
                    }
                }

                let user = getUser();

                nuevoContacto.push({
                    "blacklistPK" : {
                      "codePhone": phoneCode,
                      "phone": phone,
                      "customerUserId": user.customerUserId,
                    },
                    "customerUser":user,
                });

            }
            c++;

        })

        self.importadosBien = true;
        self.listaTerminada = true;

        self.$loading.hide();

        self.array_blacklist=nuevoContacto;

      },
    },
  }
</script>
